
type MapObjects = {
    [index: number]: number[][];
}

export const mapObjects: MapObjects = {
    1: [
        [5, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7,7, 7, 5,],
        [6, 0, 0, 0, 0, 0, 8, 8, 8, 0, 0, 0,0, 0, 6,],
        [6, 0, 8, 0, 0, 0, 8, 8, 8, 0, 8, 8,0, 0, 6,],
        [6, 0, 8, 0, 8, 0, 0, 8, 0, 0, 8, 8,8, 0, 6,],
        [6, 0, 8, 0, 8, 0, 0, 8, 0, 8, 8, 0,0, 0, 6,],
        [6, 0, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0,8, 0, 6,],
        [6, 0, 0, 0, 0, 8, 0, 0, 8, 8, 8, 0,8, 0, 6,],
        [6, 8, 8, 8, 0, 0, 8, 0, 8, 8, 0, 0,8, 0, 6,],
        [6, 0, 0, 0, 0, 8, 8, 0, 0, 0, 0, 8,0, 0, 6,],
        [6, 0, 8, 8, 0, 8, 8, 0, 0, 0, 0, 0,0, 8, 6,],
        [6, 0, 8, 8, 0, 0, 8, 0, 8, 0, 8, 0,0, 0, 6,],
        [6, 0, 0, 0, 0, 8, 8, 0, 0, 0, 8, 0,8, 0, 6,],
        [6, 8, 0, 0, 0, 0, 0, 0, 0, 8, 8, 0,8, 0, 6,],
        [6, 0, 0, 8, 8, 8, 8, 8, 0, 8, 0, 0,0, 0, 6,],
        [6, 0, 8, 0, 0, 8, 0, 0, 0, 8, 0, 0,0, 0, 6,],
        [6, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0,0, 0, 6,],
        [4, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8,8, 8, 4,],
    ],
    2: [
        [5, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7,7, 7, 5,],
        [6, 0, 0, 0, 0, 0, 8, 8, 8, 0, 0, 0,0, 0, 6,],
        [6, 0, 8, 0, 0, 0, 8, 8, 8, 0, 8, 8,0, 0, 6,],
        [6, 0, 8, 0, 8, 0, 0, 8, 0, 0, 8, 8,8, 0, 6,],
        [6, 0, 8, 0, 8, 0, 0, 8, 0, 8, 8, 0,0, 0, 6,],
        [6, 0, 8, 0, 0, 0, 0, 0, 0, 0, 0, 0,8, 0, 6,],
        [6, 0, 0, 0, 0, 8, 8, 0, 8, 8, 8, 0,8, 0, 6,],
        [6, 8, 8, 8, 0, 0, 8, 0, 8, 8, 0, 0,8, 0, 6,],
        [6, 0, 0, 0, 0, 8, 8, 0, 0, 0, 0, 8,0, 0, 6,],
        [6, 0, 8, 8, 0, 0, 0, 0, 0, 0, 0, 0,0, 8, 6,],
        [6, 0, 8, 8, 0, 8, 8, 0, 8, 0, 8, 0,0, 0, 6,],
        [6, 0, 0, 0, 0, 8, 8, 0, 0, 0, 8, 0,8, 0, 6,],
        [6, 8, 0, 0, 0, 0, 0, 0, 0, 8, 8, 0,8, 0, 6,],
        [6, 0, 0, 8, 8, 8, 8, 8, 0, 8, 0, 0,0, 0, 6,],
        [6, 0, 8, 0, 0, 8, 0, 0, 0, 8, 0, 0,0, 0, 6,],
        [6, 0, 0, 0, 0, 0, 0, 8, 0, 0, 0, 0,0, 0, 6,],
        [4, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7,7, 7, 4,],
    ],
};